module.exports = __webpack_public_path__ + "img/D_Read_more_find_support.633236b1.svg";